const TYPOGRAPHY_CSS = {
  BOLD: "bold",
  ITALIC: "italic",
  STRIKETHROUGH: "strikethrough",
  UNDERLINE: "underline",
};

/* eslint-disable-next-line */
export { TYPOGRAPHY_CSS };
